import React, { ReactNode } from 'react'
import { Container as ComponentContainer } from '@microfrontends/react-components'

type TProps = {
	sectionClass?: string[]
	container?: boolean
	containerClass?: string[]
	title?: string | ReactNode
	children: ReactNode
	ctaLink?: ReactNode
	sectionBlockStyle?: any | null
}

const Container: React.FC<{
	enable: boolean
	containerClass?: string[]
	children?: React.ReactNode
}> = ({ enable, containerClass = [], children }) => {
	if (enable) {
		return (
			<ComponentContainer
				className={`container ${containerClass.join(' ')}`}
			>
				{children}
			</ComponentContainer>
		)
	}
	return <div>{children}</div>
}

const SectionBlock = (props: TProps) => {
	const {
		title,
		sectionClass = [],
		container = true,
		ctaLink = null,
		containerClass = [],
		sectionBlockStyle = null
	} = props

	return (
		<section
			className={`sectionBlock ${sectionClass.join(' ')}`}
			style={sectionBlockStyle}
		>
			<Container enable={container} containerClass={containerClass}>
				<div className='is-flex justify-between align-center section-title'>
					{title && <h2 className='sectionBlock__title'>{title}</h2>}

					{ctaLink && (
						<div className='sectionBlock__link'>{ctaLink}</div>
					)}
				</div>

				<div className='sectionBlock__content'>{props.children}</div>
			</Container>
		</section>
	)
}

export default SectionBlock
